import { Box } from '@mui/material';

import { TenantForm } from '@/components/TenantForm';

export const Tenant = () => {
    return <TenantForm />;
};
